import React from 'react';
import { Card, CardContent } from './ui/card';
import { Link } from './ui/link';
import { cn } from '../lib/utils';

export type StatCardProps = {
  icon: React.ReactNode;
  label: string;
  value: string;
  subvalue?: React.ReactNode;
  href?: string;
  className?: string;
};

export const StatCard: React.FC<StatCardProps> = ({
  icon,
  label,
  value,
  subvalue,
  href,
  className,
}) => {
  const mainContent = (
    <>
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
        {icon}
      </div>
      <div className="min-w-0">
        <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{label}</p>
        <p className="mt-1 text-2xl font-semibold tabular-nums text-foreground">{value}</p>
      </div>
    </>
  );

  return (
    <Card className={cn('border-border/60 bg-muted/20 shadow-none', className)}>
      <CardContent className="flex flex-col gap-0.5 p-4">
        {href ? (
          <Link
            to={href}
            className="flex items-start gap-3 no-underline hover:no-underline"
          >
            {mainContent}
          </Link>
        ) : (
          <div className="flex items-start gap-3">{mainContent}</div>
        )}
        {subvalue ? (
          <div className={cn('min-w-0 text-xs text-muted-foreground', href && 'pl-12')}>
            {typeof subvalue === 'string' ? <p className="mt-0.5">{subvalue}</p> : subvalue}
          </div>
        ) : null}
      </CardContent>
    </Card>
  );
};
